import FingerprintJS from '@fingerprintjs/fingerprintjs'

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load()

;(async () => {
    // Get the visitor identifier when you need it.
    const fp = await fpPromise
    const result = await fp.get()
    const visitorId = result.visitorId

    // Log the visitorId to the console if in development mode
    if (process.env.NODE_ENV === 'development') {
        console.log(visitorId)
    }

    // Set the visitorId in a cookie with SameSite=Lax
    document.cookie = `cHash=${visitorId}; path=/; max-age=31536000; SameSite=Lax`
})()
